import { immerable } from 'immer'
import { Node } from '../../entities'
import type { AbstractNode } from '../../types'

export class NormalGraphNode extends Node implements AbstractNode {
  [immerable] = true
}
